<template>
  <div>
    <div
      class="search--section"
      :class="{
        'search--section--mobile' : isMobile,
        'search--section--desktop' : !isMobile,
      }"
    >
      <div class="title">
        <span>
          Ready-made Presentation Templates
        </span>
      </div>
      <div class="search">
        <TemplateSearchV2 />
      </div>
      <div
        class="categories"
        :class="{
          'categories--mobile' : isMobile,
          'categories--desktop' : !isMobile,
        }"
      >
        <CategoryListV2 />
      </div>
    </div>
  </div>
</template>
<script>
import CategoryListV2 from '@/components-v2/template/CategoryList-v2.vue'
import TemplateSearchV2 from '@/components-v2/template/TemplateSearch-v2.vue'

export default {
  components: {
    CategoryListV2,
    TemplateSearchV2,
  },
  props: {
  },
  data() {
    return {
      showModalPublishPresentations: false,
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 1024
    },
  },
  methods: {
  },
}
</script>
<style scoped lang='scss'>
.search--section {
  @apply pb-4 -mt-1;
  background-image: url('../../../assets/images/background/search-section-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  &.search--section--mobile {
    @apply flex flex-col;
  }
  &.search--section--desktop {
    @apply relative flex flex-col items-center justify-center;
    padding-top: 44px;
    padding-bottom: 40px;
  }
  .title {
    @apply font-bold text-base-0 text-2xl;
    text-align: center;
    @media (max-width: 1024px) {
      @apply mx-auto mt-8;
      max-width: 18rem;
    }
  }
  .categories {
    @apply mt-5;
    &.categories--mobile {
      @apply pl-6 pr-0;
    }
    &.categories--desktop {
      width: 75%;
    }
  }
  .search {
    @apply mt-5 mx-auto;
    @media (min-width: 640px) {
      @apply w-1/2;
    }
    @media (max-width: 640px) {
      width: 22rem;
    }
  }
}
</style>
